import { MemberDeptUserStoreProvider } from '../Store'

import { MemberDeptUserCascaderCore } from './Core'
import { MemberDeptUserCascaderProps } from './interface'

export const MemberDeptUserCascader = <M extends boolean>({
  /* -------------------------------------------------------------------------- */
  /*                         MemberDeptUserCascaderCore Props                         */
  /* -------------------------------------------------------------------------- */
  allowClear,
  autoFocus,
  disabled,

  /* -------------------------------------------------------------------------- */
  /*                       MemberDeptUserStoreProvider Props                      */
  /* -------------------------------------------------------------------------- */
  memberId,
  deptId,
  multiple,
  value,
  onChange
}: MemberDeptUserCascaderProps<M>) => {
  return (
    <MemberDeptUserStoreProvider
      deptId={deptId}
      memberId={memberId}
      multiple={multiple}
      value={value}
      onChange={onChange}
    >
      <MemberDeptUserCascaderCore
        allowClear={allowClear}
        autoFocus={autoFocus}
        disabled={disabled}
      />
    </MemberDeptUserStoreProvider>
  )
}
